export default __webpack_public_path__ + "static/media/house.7dead713.png";